import { useEffect, useState } from "react";

export const useTrialLoadingSteps = (
  steps: { loading: string; done: string }[]
) => {
  const [completedSteps, setCompletedSteps] = useState<Set<string>>(new Set());
  const [activeStepIndex, setActiveStepIndex] = useState(0);

  useEffect(() => {
    if (activeStepIndex >= steps.length) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setCompletedSteps((prev) => {
        const newSet = new Set(prev);
        newSet.add(steps[activeStepIndex].loading);
        return newSet;
      });
      setActiveStepIndex((prev) => prev + 1);
    }, 1500); // Simulate network/processing delay

    return () => {
      clearTimeout(timer);
    };
  }, [activeStepIndex, steps]);

  return {
    activeStepIndex,
    completedSteps,
    isAllStepsCompleted: completedSteps.size === steps.length,
  };
};
